import styled from 'styled-components';

export const ColumnWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOpen',
})`
  display: flex;
  flex-direction: column;
  padding: 0.75rem 1rem;
  position: fixed;
  width: calc(100vw - 2rem);
  z-index: 999;
  min-height: 0;
  background: #fff;
  transition: all 0.3s ease-in-out;
  z-index: 1;
  box-shadow: 0px 4px 8px 0px rgba(60, 60, 59, 0.04);
  @media (min-width: 500px) {
    padding: 0.75rem 2rem;
  }
  & #getYourQuote {
    display: flex;
    align-self: self-start;
  }
  & nav {
    max-height: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    margin: 0;
  }
  & > hr {
    max-height: 0;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  & > div:nth-child(3) {
    width: 624px;
    align-self: center;
  }
  ${(props) =>
    props.isOpen &&
    'min-height: 100vh; & nav {max-height: 60vh; opacity: 1;} @media (min-width: 500px) {& nav {max-height: 60vh;}} & > hr {max-height: unset; opacity: 1;}'}
`;

export const Divider = styled.hr.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOpen',
})`
  border-bottom: none;
  border-right: none;
  border-left: none;
  border-color: rgba(60, 60, 59, 0.3);
  width: 100%;
  margin: 0;
  ${(props) =>
    props.isOpen &&
    '@media (min-width: 500px) { margin-bottom: 2.5rem; margin-top: 1.25rem; }'}
`;
